import React, { useEffect } from "react";
import Hero from "../components/landing/Hero";
import Devices from "../components/landing/DevicesNew";
import { VideoReveal, Marquee, Manifesto, NameMeaning, Crisis } from "../components/landing/Story";
import Contrast, { SpeedGap, Retention } from "../components/landing/Contrast";
import { Impact } from "../components/landing/Science";
import { HowItWorks } from "../components/landing/HowNew";
import Proof from "../components/landing/Proof";
import Voices from "../components/landing/Voices";
import { FocusAreas } from "../components/landing/Audience";
import SpeedReader from "../components/landing/SpeedReader";
import Roadmap from "../components/landing/Roadmap";
import Closing from "../components/landing/Closing";

const Landing = () => {
  useEffect(() => {
    document.title = "vimbal – non-invasive AI brain–computer interface for calmer, faster minds";
    // The previous home page is kept at /classic so the site can switch back (siteConfig.js), but
    // it is not linked and should not appear in search results.
    if (window.location.pathname.startsWith("/classic")) {
      let meta = document.querySelector('meta[name="robots"]');
      const added = !meta;
      if (added) {
        meta = document.createElement("meta");
        meta.name = "robots";
        document.head.appendChild(meta);
      }
      const before = meta.content;
      meta.content = "noindex, nofollow";
      return () => {
        if (added) meta.remove();
        else meta.content = before;
      };
    }
    return undefined;
  }, []);
  return (
    <>
      <div id="top">
        <Hero />
        <Marquee />
        <Crisis />
        <Manifesto />
        <NameMeaning />
        <Devices />
        <Contrast />
        <SpeedGap />
        <Retention />
        <VideoReveal />
        <HowItWorks />
        <Impact />
        <FocusAreas />
        <Proof />
        <Voices />
        <Roadmap />
        <SpeedReader />
        <Closing />
      </div>
    </>
  );
};

export default Landing;
